import React from 'react';
import StatementLogo from '@portal/assets/svg/logos/statement_logo.svg?react';

interface FormattedBilletStatementProps {
  billet: string;
}

const FormattedBilletStatement = ({
  billet,
}: FormattedBilletStatementProps) => {
  return (
    <div className="formatted-billet-statement">
      <div className="formatted-billet-statement__logo">
        <StatementLogo height={30} />
      </div>
      <pre>
        {billet
          .replace(/\r\n\s+/g, '\n')
          .replace(/\r\n/g, '\n')
          .trim()}
      </pre>
    </div>
  );
};

export default FormattedBilletStatement;
